import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { useLocation } from "react-router-dom";
import { getSearchLexis } from "../api/getSearchLexis";
import { generarReporteIdentidadUnoBeta } from "../api/generarReporteIdentidadUnoBeta";
import { getCompliant } from "../api/getCompliant";
import { getApikey } from "../api/getApikey";
import Modal from "react-bootstrap/Modal";
import logo from "../assets/dpr_lab_logo.png";
import check1 from "../assets/Check1.png";
import "./print.css";
import "./style.css";
import "./styleBack.css";
import { jsPDF } from "jspdf";

const BackgroundCheck = () => {
  const componentRef = useRef(null);
  const isRunned = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [cpv, setCpv] = useState(params.get("i"));
  const [emiteTxt, setEmiteTxt] = useState("");
  const [tendenciaBl, setTendenciaBl] = useState(false);
  const [qr, setQr] = useState("");

  const [nombres, setNombres] = useState("");
  const [validacionNombre, setvalidacionNombre] = useState(false);
  const [vigencia, setVigencia] = useState("");
  const [primerApellido, setPrimerApellido] = useState("");
  const [segundoApellido, setSegundoApellido] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [generoOficial, setGeneroOficial] = useState("");
  const [nacionalidades, setNacionalidades] = useState("");
  const [selfie, setSelfie] = useState("");
  const [numIdentificacionNacionalNumero, setNumIdentificacionNacionalNumero] =
    useState("");
  const [personaPol, setpersonaPol] = useState("No");

  const [listModelEnforcement, setlistModelEnforcement] = useState([]);
  const [listAlertas, setlistAlertas] = useState([]);
  const [listModelRespuesta, setlistModelRespuesta] = useState([]);
  const [shoModalBuho, setShoModalBuho] = useState(false);

  const date = new Date();
  const formattedDate = date
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {
      localStorage.clear();

      if (params.get("i") == null) {
        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv");
      } else {
        setLoading(true);

        const objCpv = {
          cpv: params.get("i"),
        };

        const responseN1 = await generarReporteIdentidadUnoBeta(objCpv);

        if (responseN1.status === 200) {

          //******  Lexis  *****//

          const response = await getSearchLexis(objCpv);

          if (response.status !== 500 && response.status !== 400) {

            if (response.status === 200) {
              setlistModelEnforcement(response.listModelEnforcement);
              setTendenciaBl(true);
              setpersonaPol("Sí");
            }

            //******  Buho legal  *****//

            const responseBuhoLegal = await getApikey(objCpv);

            if (responseBuhoLegal.status === 200) {

              setlistAlertas(responseBuhoLegal.listModelResponseBuhoLegal);
              setTendenciaBl(true);

            }

            if (responseBuhoLegal.status === 500) {
              setLoading(false);
              setShow(true);
              setShowStatus(responseBuhoLegal.status);
              setShowMessage(responseBuhoLegal.message);
              setShoModalBuho(true);
            }

            //******  Compliant   *****//

            const responseCompliant = await getCompliant(objCpv);

            if (responseCompliant.status === 200) {
              setlistModelRespuesta(responseCompliant.listModelRespuesta);
              setTendenciaBl(true);
            }

            const qrStr =
              "data:image/png;base64," + responseN1.qr + "";

            setQr(qrStr);
            setCpv(responseN1.cpv);
            setNombres(responseN1.nombres);
            setVigencia(responseN1.vigencia);
            setPrimerApellido(responseN1.primerApellido);
            setSegundoApellido(responseN1.segundoApellido);

            if (responseN1.nameFullCompleto === true) {
              setvalidacionNombre(true);
            }

            const selfieStr = "" + responseN1.selfie + "";
            setSelfie(selfieStr);
            setFechaNacimiento(responseN1.fechaNacimiento);
            setGeneroOficial(responseN1.generoOficial);
            setNacionalidades(responseN1.nacionalidades);
            setNumIdentificacionNacionalNumero(
              responseN1.numIdentificacionNacionalNumero
            );

            if (responseBuhoLegal.status !== 500) {
              handlePrint();
            }

          } else {
            setLoading(false);
            setShow(true);
            setShowStatus(response.status);
            setShowMessage(response.message);
          }

        } else {
          setLoading(false);
          setShow(true);
          setShowStatus(responseN1.status);
          setShowMessage(responseN1.message);
        }
      }
    }

    createSession();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    print: async () => {
      const doc = new jsPDF();
      doc.html(componentRef.current, {
        html2canvas: {
          removeContainer: true,
          scale: 0.19,
        },
        margin: 5,
        x: -1,
        async callback(doc) {
          await doc.save(
            "Antecedentes Personales " + cpv + "_" + formattedDate
          );
        },
      });
    },
  });

  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className="backGroudModal">
          <div className="msjTitleModalDiv">Error {showStatus}</div>
          <div className="msjErrorModal">{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="button_P2" onClick={handleClose}>
            <span className="txtButton_P2">Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

      <div
        className="w-100  justify-content-center"
        style={{ display: "flex", width: "965px", border: "none" }}
      >
        <div
          className=" animate__animated animate__fadeIn"
          ref={componentRef}
          style={{ display: "flex", width: "1070px", border: "none" }}
        >
          <div className="relativeCSS">
            <style type="text/css" media="print">
              {"@page {  size: A4;  }"}
            </style>

            {/* hoja 1 */}
            <br />
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <div style={{ margin: "15px" }}>
                    <article className="newCard__style ">
                      <div className="Bar__top p-2">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-3">
                              <img src={logo} alt="" className="w-100" />
                            </div>
                            <div className="col-9 ">
                              <div className="subtitle d-flex justify-content-start  h-100">
                                <div className="mt-3">
                                  <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                  <br />
                                  <h5 className="Bar__top--sizing p-0">
                                    Antecedentes Personales
                                  </h5>
                                </div>
                                <section className="mt-2">
                                  <div className="Bar__button--color rounded-pill">
                                    <span className="p-1">
                                      <strong>CAD</strong>
                                    </span>
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="conteiner-fluid info-Bar">
                        <div className="row p-3 ">
                          <div className="col-8">
                            <ul className="pNone text-start p-3">
                              <li className="d-flex justify-content-start align-items-center mb-2">
                                <img
                                  src={check1}
                                  alt=""
                                  className="imgCheck--size"
                                />
                                <span className="f20 pb-1">
                                  Nombre Completo
                                </span>
                              </li>
                              <li className="d-flex justify-content-start align-items-center mb-2">
                                <img
                                  src={check1}
                                  alt=""
                                  className="imgCheck--size"
                                />
                                <span className="f20 pb-1">
                                  Fecha &nbsp; de &nbsp; nacimiento
                                </span>
                              </li>
                              <li className="d-flex justify-content-start align-items-center mb-2">
                                <img
                                  src={check1}
                                  alt=""
                                  className="imgCheck--size"
                                />
                                <span className="f20 pb-1"> Nacionalidad</span>
                              </li>
                            </ul>
                            <div className=" d-flex Info__aling">
                              <div className="expires">
                                <span className="text-lg">
                                  Vence: &nbsp;: <strong> {vigencia}</strong>{" "}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <section className=" d-flex flex-column w-100">
                              <img className="  " src={qr} alt="" />
                              <span className="cpv__text  text-center mt-1">
                                CPV&nbsp;: <strong>{cpv}</strong>{" "}
                              </span>
                            </section>
                          </div>
                        </div>
                      </div>
                    </article>
                    <div className="text-one">
                      <div className="textInfo f12">
                        ATENCIÓN &nbsp;:&nbsp; Este certificado es válido
                        únicamente si la fecha en el recuadro superior izquierdo
                        de este Reporte se encuentra vigente. Para comprobar su
                        autenticidad escanee el código QR y/o ingrese el código
                        CPV en www.midpr.net.
                      </div>
                    </div>
                    <div className="textNotifique pt-0">
                      *Notifique si este Reporte ha sido alterado al +52
                      5571605526 y/o en www.midpr.net
                    </div>
                  </div>
                  <br />
                </div>
                <div className="col-6">
                  <div style={{ margin: "15px" }}>
                    <div className="subTitleCardTwo f12 subTitleCardTwo__sizing">
                      Este &nbsp; Reporte da constancia de la recopilación y
                      corroboración de información aportada por el Aplicante a
                      través de medios digitales, de manera completa y
                      concluyente, obteniendo la información presentada a
                      continuación:
                    </div>
                    <br />
                    <article className="card digital-data">
                      <div className="titleCard">DATOS &nbsp; CONSULTADOS</div>
                      <div className="f12">
                        <div className="container_back">
                          <div className="image-container_back">
                            <img
                              src={selfie}
                              alt="userPicture"
                              className="Card__userPic"
                            />
                          </div>
                          <div className="details-container_back">
                            <ul>
                              {validacionNombre ? (
                                <>
                                  <li>
                                    <span>
                                      Nombres:
                                      <strong> {nombres}</strong>
                                    </span>
                                  </li>
                                  <li>
                                    <span>
                                      Apellidos:
                                      <strong>
                                        {" "}
                                        {primerApellido} {segundoApellido}
                                      </strong>
                                    </span>
                                  </li>
                                </>
                              ) : (
                                <>
                                  <li>
                                    <span>
                                      Nombre:
                                      <strong> {nombres}</strong>
                                    </span>
                                  </li>
                                </>
                              )}
                              <li>
                                <span>
                                  Fecha &nbsp; de &nbsp; nacimiento:
                                  <strong> {fechaNacimiento}</strong>
                                </span>
                              </li>
                              <li>
                                <span>
                                  Género:
                                  <strong> {generoOficial}</strong>
                                </span>
                              </li>
                              <li>
                                <span>
                                  Nacionalidad:
                                  <strong> {nacionalidades}</strong>
                                </span>
                              </li>
                              <li>
                                <span>
                                  NIN:
                                  <strong>
                                    {" "}
                                    {numIdentificacionNacionalNumero}
                                  </strong>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </article>
                    <div className="d-flex justify-content-center  align-items-center mt-2 mb-2 ">
                      <button type="button" className=" rounded-pill BtnN4 p">
                        <span className="btnDatosConsulta_back">
                          Persona &nbsp; políticamente expuesta:{" "}
                        </span>
                        <strong>{personaPol}</strong>
                      </button>
                    </div>
                    <div className="textNotifique_back pt-0">
                      *La interpretación de este Resultado Obtenido es
                      responsabilidad exclusiva del lector.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <div style={{ margin: "15px" }}>
                    <div className="card">
                      <div className="titleCard_back pt-1">LISTAS &nbsp; NEGRAS</div>
                      <div style={{ fontSize: "10px" }}>
                        {listModelEnforcement.length > 0 ? (
                          listModelEnforcement.map((actividad, index) => (
                            <div key={index}>
                              <div>
                                <span>
                                  <strong>País: </strong>
                                  {actividad.pais}
                                </span>
                              </div>
                              <div>
                                <span>
                                  <strong>Fuente: </strong>
                                  {actividad.source}
                                </span>
                              </div>
                              <div>
                                <span>
                                  <strong>Categoría/s: </strong>
                                  {actividad.subcategory}
                                </span>
                              </div>
                              <br />
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: "13px", fontWeight: "600" }}>
                            No se encontraron registros.
                            <div style={{ height: "400px" }}></div>
                          </div>
                        )}
                      </div>
                    </div>
                    <br />
                    <div className="buttonCenter">
                      {!tendenciaBl ? (
                        <>
                          <div className="d-flex justify-content-center  align-items-center">
                            <button
                              type="button"
                              className="btn green trend rounded-pill"
                            >
                              <strong>Alerta:&nbsp;  Inexistente </strong>
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-flex justify-content-center  align-items-center">
                            <button
                              type="button"
                              className="btn yellow trend rounded-pill"
                            >
                              <strong>Alerta:&nbsp; Existente</strong>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="f12--sizing text-center pt-1">
                      *Consulte definiciones de estas métricas en www.midpr.net.
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div style={{ margin: "15px" }}>
                    <div className="card evaluated-areas tipo-d borderCard pt-1">
                      <div className="titleCard_back">ANTECEDENTES &nbsp; LEGALES</div>
                      <div style={{ fontSize: "10px" }}>
                        {listAlertas.length > 0 ? (
                          listAlertas.map((actividad, index) => (
                            <div key={index}>
                              <div>
                                <strong> Expediente: </strong>
                                {actividad.expediente} <br />
                                <strong> Actor: </strong>
                                {actividad.actor} <br />
                                <strong> Demandado: </strong>
                                {actividad.demandado} <br />
                              </div>
                              <br />
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: "13px", fontWeight: "600" }}>
                            No se encontraron registros.
                            <div style={{ height: "400px" }}></div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="textNotifique pt-1">
                      *Consulte al reverso de este Reporte las observaciones
                      recabadas.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="note-gray note-emit">
                <p>{emiteTxt}</p>
                <span style={{ fontSize: "11px" }}>
                  Se emite el presente &nbsp; Reporte el 15 de 02 de 2024 a las 12:00
                  UTC en calidad de Información &nbsp; Confidencial.
                </span>
              </div>
              <div className="textNotifique pt-1">
                *Consulte al reverso nuestra Política de Privacidad y/o en
                www.midpr.net
              </div>

              <div className="card legal-advise borderCard">
                <div className="titleCard  TitleAviso pb-1">
                  AVISO &nbsp; LEGAL
                </div>
                <div className="subTitleCardTwo f12 ">
                  <p>
                    La Calificación realizada de manera remota por el Aplicante,
                    a la que hace referencia este Reporte, fue realizada a
                    solicitud directa del Destinatario. Antes y durante la
                    Calificación &nbsp;, fue autenticada la identidad del
                    Aplicante y se registraron una serie de datos e información
                    de carácter personal con su autorización expresa &nbsp;, lo
                    cual permitió emitir una Evaluación Remota Confiable (&nbsp;
                    ERC &nbsp;). El Destinatario acepta que todos los datos
                    contenidos en el presente Reporte son confidenciales y de
                    interés exclusivo y privado, que es compartida únicamente
                    con el propósito que ha sido previamente informado por el{" "}
                    Destinatario y que ha autorizado por el Aplicante previo a
                    la aplicación de la Calificación &nbsp;. El Aplicante y/o el{" "}
                    Destinatario de este Reporte aceptan de conformidad la
                    responsabilidad sobre cualquier uso indebido o ilegal de
                    este documento y su contenido, así como todos los términos y
                    condiciones descritos al reverso. Una vez entregado este
                    Reporte al Destinatario, el Fabricante se deslinda de toda
                    responsabilidad sobre su interpretación, divulgación y uso .
                  </p>
                </div>
              </div>
              <div className="textNotifique f12">
                Business &nbsp; Prey &nbsp; SA &nbsp; de &nbsp; CV  &nbsp; hace referencia que con número de
                registro DGSP&nbsp;/369-19/3919, está autorizada por la &nbsp;
                SSPC &nbsp; /DGSP &nbsp; para la aplicación de Pruebas &nbsp; y &nbsp; Evaluación
                &nbsp; de Control de Confianza de conformidad con los
                Lineamientos y Criterios Técnicos &nbsp; publicados en el Diario
                Oficial de la Federación (DOF) el 28 de abril de 2020.
              </div>
              <div style={{ paddingTop: "", background: "#FFF" }}></div>
            </div>
            <div style={{ height: "30px" }}></div>

            {/* hoja 2 */}
            <div className="div-vertical mt-15">
              <div className="div-horizontal" id="div1">
                <div className="card evaluated-areas tipo-d borderCard">
                  <div className="titleCard_back">NOTICIAS &nbsp; NEGATIVAS</div>
                  <div style={{ fontSize: "10px" }}>
                    {listModelRespuesta.length > 0 ? (
                      listModelRespuesta.map((actividad, index) => (
                        <div key={index}>
                          <div>{actividad.title}</div>
                          <div>{actividad.snippet}</div>
                          <br />
                        </div>
                      ))
                    ) : (
                      <div style={{ fontSize: "13px", fontWeight: "600" }}>
                        No se encontraron registros.
                        <div style={{ height: "400px" }}></div>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <div>
                    <div className="subTitleCardTwo f12">
                      <strong> Privacidad de Datos Personales </strong>
                    </div>
                    <div className="subTitleCardTwo f12">
                      Para efectos del cumplimiento del artículo 9 de la Ley
                      Federal de Protección de Datos Personales en Posesión de
                      los Particulares &nbsp; (LFPDPPP&nbsp;), &nbsp; el Aplicante del CAD
                      manifiesta expresamente que otorgó su consentimiento para
                      el tratamiento de sus datos personales sensibles, durante
                      los procedimientos de recopilación y procesamiento,
                      aceptando los términos y condiciones para tales efectos.
                    </div>
                  </div>
                  <div>
                    <div className="subTitleCardTwo f12">
                      <strong>Uso de las Marcas</strong>
                    </div>
                    <div className="subTitleCardTwo f12">
                      DPR y las marcas asociadas son marcas registradas,
                      protegida por los artículos 88 y 142 de la Ley de
                      Propiedad Industrial (LPI&nbsp;), así como el convenio de París
                      para efectos internacionales. El consumo o adquisición de
                      cualquiera de los servicios vinculados a DPR &nbsp; y/o
                      proporcionados por el Fabricante, no confieren al
                      Aplicante y/o al Destinatario el derecho de uso de las
                      marcas de DPR en ningún contexto y/o formato, ya que al
                      hacerlo podría resultar en actividad fraudulenta y ser
                      clasificado como un delito. La marca, propiedad
                      intelectual o cualquier otro tipo de secreto industrial
                      contenido en este Reporte, no autoriza el uso, explotación
                      comercial, venta, reproducción o distribución de dicha
                      información.
                    </div>
                  </div>
                  <div>
                    <div className="subTitleCardTwo f12">
                      <strong> Uso de Información por Terceros </strong>
                    </div>
                    <div className="subTitleCardTwo f12">
                      Al realizar el CAD, el Aplicante autoriza la entrega de
                      los datos obtenidos al Destinatario para el uso particular
                      que ambos hayan acordado.
                    </div>
                  </div>
                </div>
                <div>
                  <div className="note-gray ">
                    <p>
                      <strong>Business &nbsp; Prey SA de CV</strong> con
                      domicilio en Alfonso Reyes 216 Dep L003, Col. Hipódromo,
                      C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es
                      Fabricante exclusivo de DPR. Para mayor información llame
                      al +52 5571605526 o visite el sitio{" "}
                      <strong>www.midpr.net</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BackgroundCheck;
